// extracted by mini-css-extract-plugin
module.exports = {"view":"styles_view__22iN9","report":"styles_report__34ctw"};